import { useQuery } from '@tanstack/react-query'
import { getChannelTransactionCumulative } from '../../services'
import { GetChannelTransactionCumulativeRequest } from '../../../type'
import { DashboardKeys } from '@/modules/dashboard/keys'

export const useQueryChannelTransactionCumulative = (
	channelId: string,
	params: GetChannelTransactionCumulativeRequest,
) => {
	return useQuery({
		queryKey: [DashboardKeys.ChannelTransactionCumulative, channelId, params],
		queryFn: () => getChannelTransactionCumulative(channelId, params),
	})
}

export default useQueryChannelTransactionCumulative
